<script setup lang="ts">
import FeedResultCard from "~/components/layout/Search/Feeds/FeedResultCard.vue";
import { IFollowingsResult } from "~/components/layout/Search/SearchResults.vue";
import { IEntityTop } from "~/types/graph-ql/graphql-types";
import t from "~/utils/translate";

interface Props {
	followings: (IFollowingsResult | IEntityTop)[] | null;
	homePage?: boolean;
}
const props = defineProps<Props>();

const teams = computed(() => {
	return props.followings?.filter((f) => f.type === "TEAM");
});
const leagues = computed(() => {
	return props.followings?.filter((f) => f.type === "COMPETITION");
});
</script>

<template>
	<div v-if="teams && teams.length > 0">
		<div class="mb-1 px-2 font-bold">{{ t("search-team-results") }}:</div>
		<FeedResultCard v-for="(following, idx) in teams" :type="'TEAM'" :homePage="homePage" :following="following as IFollowingsResult" :key="idx" />
	</div>
	<div v-if="leagues && leagues.length > 0">
		<div class="mb-1 px-2 font-bold">{{ t("search-league-results") }}:</div>
		<FeedResultCard
			v-for="(following, idx) in leagues"
			:following="following as IFollowingsResult"
			:homePage="homePage"
			:type="'COMPETITION'"
			:key="idx"
		/>
	</div>
</template>

<style scoped lang="scss"></style>
